module.exports = __webpack_public_path__ + "static/img/Charlotte-Grant.07f664c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Charlotte-Grant.jpg
// module id = Ynas
// module chunks = 0